import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationRequest, NotificationResponse } from '../models/notification.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private baseUrl = environment.notificationsApiUrl;

  constructor(private http: HttpClient) { }

  sendNotification(notification: NotificationRequest): Observable<NotificationResponse> {
    const url = `${this.baseUrl}/notifications/send`;
    return this.http.post<NotificationResponse>(url, notification)
  }

}
